import { getPageData } from 'ka-table/Utils/PagingUtils';

const pageSize = 10;

const get = (pageIndex, dataArray) => new Promise((resolve) => {
  setTimeout(() => {
    const data = getPageData(dataArray, {
      enabled: true,
      pageSize,
      pageIndex
    });
    // eslint-disable-next-line no-param-reassign
    pageIndex = data[data.length - 1] !== dataArray[dataArray.length - 1] ?
    pageIndex + 1 :
    -1;
    resolve({
      data,
      pageIndex
    });
  }, 200);
});

export default {
  get
};